$(document).ready(function ()
{

    window.onscroll = function() { myFunction() };

    var preheader = document.getElementById("pre-header");
    var header = document.getElementById("site-header");
    var sticky = header.offsetTop;

    function myFunction() {
        if (window.pageYOffset > 40) 
        {
            $('html').addClass('sticky'); 
        } else {
            $('html').removeClass('sticky'); 
        }
    }

    var nav_span = $(".nav-span");

    $("#nav-toggler").click(function ()
    {
        if (nav_span.hasClass("nav-lines"))
        {
            nav_span.removeClass("nav-lines");
            nav_span.addClass("nav-cross"); 
            $("#searchContainer").removeClass("active");
            $('body').addClass('nav-toggle-is-active'); 
        }
        else
        {
            nav_span.removeClass("nav-cross");
            nav_span.addClass("nav-lines");
            $('body').removeClass('nav-toggle-is-active');
        }
    });

    $(".overlay-submenu-toggle").click(function(e)
    {
        e.preventDefault();

        var theParent = $(this).closest( "li" );
        var is_open = theParent.hasClass("active");

        $('.main-navigation .parent-link').removeClass("active");

        if (!is_open)
        {
            $( theParent ).addClass("active"); 
        }
    });

    $("#searchToggler").on('click', function(e) 
    {
        e.preventDefault();
        if ($("#searchContainer").hasClass("active"))
        {
            //$('.header-overlay').hide();  
            $("#searchContainer").removeClass("active");
            //$('body').removeClass('fixedBody');
        }
        else
        {
            nav_span.removeClass("nav-cross");
            nav_span.addClass("nav-lines");
            $('body').removeClass('nav-toggle-is-active');
            //$('.header-overlay').show();  
            $("#searchContainer").addClass("active");
            //$('body').addClass('fixedBody');
        }
        
        //$("html").toggleClass("no-scroll");
    });

    $(".search-close").on('click', function(e) {
        e.preventDefault();
        $("#searchContainer").removeClass("active");
        //$('body').removeClass('fixedBody');
       // $('.header-overlay').hide();  
        //$("html").removeClass("no-scroll");
    });

});